import React from 'react';

import {usePanelSearchDebouncedContext} from '../../state/panelbank/PanelSearchContextProvider';
import {type PlotFontSize} from '../../util/plotHelpers/plotFontSize';
import {useIsFullScreenPanel} from '../Panel/hooks/useIsFullScreenPanel';
import {usePanelContext} from '../Panel/PanelContextProvider';
import {PanelPopupMode} from '../Panel/types';
import {PanelTitleView} from './PanelTitleView';

interface PanelTitleProps {
  title: string;
  fontSize?: PlotFontSize | 'auto';
  disallowSelect?: boolean;
}

/**
 * Reads panel search, full-screen state, and the panel popup setter, then
 * renders PanelTitleView. Clicking the title opens the panel editor.
 */
export const PanelTitle: React.FC<PanelTitleProps> = ({
  title,
  fontSize,
  disallowSelect,
}) => {
  const {makeHighlightSearchTitle} = usePanelSearchDebouncedContext();
  const {isFullScreen} = useIsFullScreenPanel();
  const {setPanelPopupMode} = usePanelContext();

  const handleClick = () => {
    setPanelPopupMode(PanelPopupMode.EDIT);
  };

  return (
    <PanelTitleView
      disallowSelect={disallowSelect}
      fontSize={fontSize}
      highlightSearch={isFullScreen ? undefined : makeHighlightSearchTitle}
      onTitleClick={handleClick}
      title={title}
    />
  );
};
